import { useQuery } from "@tanstack/react-query";
import { getPosts } from "../lib/sanity/client.js";
import { Link } from "react-router-dom";
import { urlFor } from "../lib/sanity/image.js";
import "./Blogs.css";

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}

const Blogs = () => {
  const {
    data: posts,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["posts"],
    queryFn: getPosts,
  });

  if (isLoading) return <p className="blog-loading">Loading posts...</p>;
  if (error) return <p className="blog-loading">Failed to load posts</p>;

  return (
    <div className="blogs-container">
      <h2 className="blogs-header">Our Blog</h2>

      <div className="blogs-grid">
        {posts.map((post) => (
          <div key={post._id} className="blogs-card">
            <Link to={`/blogs/${post.slug.current}`} className="blogs-link">
              {post?.mainImage && (
                <img
                  src={urlFor(post.mainImage)
                    .width(800)
                    .height(400)
                    .quality(80)
                    .auto("format")
                    .url()}
                  alt={post.mainImage.alt || post.title}
                  className="blogs-image"
                />
              )}
              <p className="blogs-date">
                {formatDate(post.publishedAt)}
              </p>
              <h2 className="blogs-title">{post.title}</h2>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
